import { Component, OnInit } from "@angular/core";
import { AuthService } from "@app/auth/services/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthTokenService } from "@app/auth/services/auth-token.service";
import * as FullStory from "@fullstory/browser";
import { UserService } from "@app/shared/services/user.service";
import { StoreService } from "@app/shared/services/store.service";

@Component({
  selector: "beta-redirect",
  templateUrl: "./redirect.component.html",
  styleUrls: ["./redirect.component.scss"],
})
export class RedirectComponent implements OnInit {
  error: string | undefined;
  passwordError: string | undefined;
  emailError: string | undefined;
  email: string;
  password: string;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private authTokenService: AuthTokenService,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.checkForBetaLogin();
  }

  checkForBetaLogin() {
    const token = this.route.snapshot.queryParams.t;
    const refresh = this.route.snapshot.queryParams.r;

    if (!!token && !!refresh) {
      this.authTokenService.setTokens(token, refresh);
      this.userService.show().subscribe((response) => {
        const user = response;
        this.userService.setUser(user);
        this.router.navigateByUrl("/dashboard");
      }, (error) => {
        this.router.navigateByUrl("/login");
      });
    } else {
      this.router.navigateByUrl("/login");
    }
  }
}
